import React, { Component } from "react";
import "./Footer.css";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import logo from "../../assets/images/logo.png";
import submit from "../../assets/images/submit.png";

const contactTitle = {
  Srpski: "Kontakt",
  English: "Contact",
  Italian: "Contatto"
};

const atelierInfo = {
  Srpski: "Atelje",
  English: "Atelier",
  Italian: "Atelier"
};

const storeInfo = {
  Srpski: "Radnja",
  English: "Store",
  Italian: "Negozio"
};

const srbija = {
  Srpski: "Srbija",
  English: "Serbia",
  Italian: "Serbia"
};

const phone = {
  Srpski: "Telefon",
  English: "Phone",
  Italian: "Telefono"
};

const newsletterTitle = {
  Srpski: "PRIJAVA NA NEWSLETTER",
  English: "NEWSLETTER SIGNUP",
  Italian: "ACCEDI ALLA NEWSLETTER"
};

const smTitle = {
  Srpski: "PRATITE NAS",
  English: "FOLLOW US",
  Ialian: "SEGUICI"
};

class Footer extends Component {
  constructor() {
    super();
    this.state = {
      placeholder: {
        Srpski: "E-mail adresa",
        English: "E-mail address",
        Italian: ""
      }
    };
  }

  scrollToTop() {
    window.scrollTo(0, 0);
  }

  renderMailchimp() {
    return (
      <div id="mc_embed_signup" className="Chimp">
        <form
          action="https://igortodorovic.us19.list-manage.com/subscribe/post?u=a32054de1d76c44d4012c6579&amp;id=59218be9c7"
          method="post"
          id="mc-embedded-subscribe-form"
          name="mc-embedded-subscribe-form"
          className="validate"
          noValidate
        >
          <div id="mc_embed_signup_scroll">
            <div className="mc-field-group">
              <input
                type="email"
                name="EMAIL"
                className="required email"
                id="mce-EMAIL"
              />
            </div>
            <div
              style={{ position: "absolute", left: "-5000px" }}
              aria-hidden="true"
            >
              <input
                type="text"
                name="b_a32054de1d76c44d4012c6579_cfedb4ba01"
                tabIndex="-1"
              />
            </div>
            <div className="Newsletter" style={{ position: "absolute" }}>
              <div className="SubmitWrapper">
                <img src={submit} alt="submit" />
              </div>
            </div>
            <input
              type="submit"
              value="Subscribe"
              name="subscribe"
              id="mc-embedded-subscribe"
              className="button mailchimp-invisible"
            />
          </div>
        </form>
      </div>
    );
  }

  render() {
    const { language } = this.props;
    return (
      <div className="Footer">
        <div className="Footer-Left">
          <div className="Footer-Left-Upper">
            <img className="LogoFooter" src={logo} alt="Igor Atelier" />
          </div>
          <div className="Footer-Left-Lower">
            <a
              href="https://vitaminstudio.rs/"
              target="_blank"
              rel="noreferrer noopener"
            >
              Powered by Vitaminstudio
            </a>
          </div>
        </div>
        <div className="Footer-Center">
          <div className="Footer-Center-Lower">
            <h3>{contactTitle[language]}</h3>
            <p>
              {atelierInfo[language]} - Lamartinova 23, {storeInfo[language]} -
              Kralja Petra 36, 11000 Beograd, {srbija[language]}
            </p>
            <p>
              <span>{phone[language]}:</span> +381112623371, +381112432169,
              +381628494943
            </p>
            <a href="mailto:info@igortodorovic.com">
              <span>E-mail:</span>
              info@igortodorovic.com
            </a>
          </div>
        </div>
        <div className="Footer-Right">
          <div className="Footer-Right-Upper">
            <h3>{newsletterTitle[language]}</h3>
            {this.renderMailchimp()}
          </div>
          <div className="Footer-Right-Lower">
            <h3>{smTitle[language]}</h3>
            <div className="SocialMedia">
              <a
                href="https://www.facebook.com/AteljeIgorTodorovic/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <svg
                  className="SvgFooter"
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <path d="M22.675 0h-21.35c-.732 0-1.325.593-1.325 1.325v21.351c0 .731.593 1.324 1.325 1.324h11.495v-9.294h-3.128v-3.622h3.128v-2.671c0-3.1 1.893-4.788 4.659-4.788 1.325 0 2.463.099 2.795.143v3.24l-1.918.001c-1.504 0-1.795.715-1.795 1.763v2.313h3.587l-.467 3.622h-3.12v9.293h6.116c.73 0 1.323-.593 1.323-1.325v-21.35c0-.732-.593-1.325-1.325-1.325z" />
                </svg>
              </a>
              <a
                href="https://www.instagram.com/ateljeigortodorovic/?hl=en"
                target="_blank"
                rel="noopener noreferrer"
              >
                <svg
                  className="SvgFooter"
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <path d="M21.231 0h-18.462c-1.529 0-2.769 1.24-2.769 2.769v18.46c0 1.531 1.24 2.771 2.769 2.771h18.463c1.529 0 2.768-1.24 2.768-2.771v-18.46c0-1.529-1.239-2.769-2.769-2.769zm-9.231 7.385c2.549 0 4.616 2.065 4.616 4.615 0 2.549-2.067 4.616-4.616 4.616s-4.615-2.068-4.615-4.616c0-2.55 2.066-4.615 4.615-4.615zm9 12.693c0 .509-.413.922-.924.922h-16.152c-.511 0-.924-.413-.924-.922v-10.078h1.897c-.088.315-.153.64-.2.971-.05.337-.081.679-.081 1.029 0 4.079 3.306 7.385 7.384 7.385s7.384-3.306 7.384-7.385c0-.35-.031-.692-.081-1.028-.047-.331-.112-.656-.2-.971h1.897v10.077zm0-13.98c0 .509-.413.923-.924.923h-2.174c-.511 0-.923-.414-.923-.923v-2.175c0-.51.412-.923.923-.923h2.174c.511 0 .924.413.924.923v2.175z" />
                </svg>
              </a>
              <button>
                <svg
                  className="SvgFooter"
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <path d="M24 4.557c-.883.392-1.832.656-2.828.775 1.017-.609 1.798-1.574 2.165-2.724-.951.564-2.005.974-3.127 1.195-.897-.957-2.178-1.555-3.594-1.555-3.179 0-5.515 2.966-4.797 6.045-4.091-.205-7.719-2.165-10.148-5.144-1.29 2.213-.669 5.108 1.523 6.574-.806-.026-1.566-.247-2.229-.616-.054 2.281 1.581 4.415 3.949 4.89-.693.188-1.452.232-2.224.084.626 1.956 2.444 3.379 4.6 3.419-2.07 1.623-4.678 2.348-7.29 2.04 2.179 1.397 4.768 2.212 7.548 2.212 9.142 0 14.307-7.721 13.995-14.646.962-.695 1.797-1.562 2.457-2.549z" />
                </svg>
              </button>
              <a
                href="https://www.youtube.com/channel/UCjPA_0FG25s3Eu_oPL_qZaQ"
                target="_blank"
                rel="noopener noreferrer"
              >
                <svg
                  className="SvgFooter"
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <path d="M19.615 3.184c-3.604-.246-11.631-.245-15.23 0-3.897.266-4.356 2.62-4.385 8.816.029 6.185.484 8.549 4.385 8.816 3.6.245 11.626.246 15.23 0 3.897-.266 4.356-2.62 4.385-8.816-.029-6.185-.484-8.549-4.385-8.816zm-10.615 12.816v-8l8 3.993-8 4.007z" />
                </svg>
              </a>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    language: state.language
  };
}

export default withRouter(connect(mapStateToProps)(Footer));



// WEBPACK FOOTER //
// ./src/components/Footer/index.js